// Shared by the home page sections that show catalog products.

// Number of projects the hero bento shows (one lead + four tiles).
export const HERO_SLOTS = 5;

// Blogger serves the original upload for /s16000/; a small rendition is plenty for a thumbnail.
export const sizedImage = (url, width = 240) =>
  url && /googleusercontent\.com/.test(url)
    ? url.replace(/\/s\d+\//, `/w${width}/`)
    : url;

export const coverOf = (product, width) => {
  const media = product?.media || [];
  const image =
    media.find(m =>
      String(m?.type || m?.mimeType || '')
        .toLowerCase()
        .includes('image')
    ) || media[0];
  return sizedImage(image?.url || '', width);
};

export const formatPrice = price => {
  const amount = Number(price);
  if (!Number.isFinite(amount)) return '';
  if (amount === 0) return 'Free';
  return `₹${amount.toLocaleString('en-IN')}`;
};

export const productPath = product =>
  `/products/${product.id}/${encodeURIComponent(product.name || 'project')}`;

const liveProducts = products =>
  products.filter(p => p && p.isActive !== false);

// Featured projects first, then the rest of the catalog fills any empty tiles.
export const pickHeroProjects = products => {
  const live = liveProducts(products);
  const featured = live.filter(p => p.isFeatured);
  const others = live.filter(p => !p.isFeatured);
  return [...featured, ...others].slice(0, HERO_SLOTS);
};

// Newest projects that the hero isn't already showing.
export const pickLatestProjects = (products, count) => {
  const shown = new Set(pickHeroProjects(products).map(p => p.id));
  return liveProducts(products)
    .filter(p => !shown.has(p.id))
    .sort(
      (a, b) =>
        new Date(b.createdDate || 0).getTime() -
        new Date(a.createdDate || 0).getTime()
    )
    .slice(0, count);
};
